import script from "./list-accessory-slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-accessory-slug.vue?vue&type=script&setup=true&lang=ts"

import "./list-accessory-slug.vue?vue&type=style&index=0&id=1e43e08c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e43e08c"]])

export default __exports__